import React from 'react';
import { useRef, useState } from 'react';
import Slider from 'react-slick';

/* DOCS
https://react-slick.neostack.com/docs/get-started
*/

const SimpleSlider = React.memo(function SimpleSlider({ settings, children, isDashboard, cssClasses = '' }) {
	const sliderRef = useRef(null);
  return (
		<Slider {...settings} ref={sliderRef} className={isDashboard ? 'h-80p ' : 'carousel-slider ' + cssClasses}>
			{children}
		</Slider>
  );
});

export default SimpleSlider;
